import { render, staticRenderFns } from "./BuildingSearch.vue?vue&type=template&id=31784238&"
import script from "./BuildingSearch.vue?vue&type=script&lang=js&"
export * from "./BuildingSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports